import type { AxiosInstance } from 'axios';
import { ProductModel } from '@/models/product';
import { Product } from '../types/product';
import { transformProduct } from '../transforms/product';

class ProductService {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async toggleProduct(productId: string, isOrderable: boolean): Promise<ProductModel> {

    const response = await this.client.patch<Product>(`/products/${productId}`, {
      isOrderable,
    });

    return transformProduct(response.data);
  }
}

export { ProductService };
